import TextField from "@mui/material/TextField";
import {Stack} from "@mui/material";
import * as React from "react";
import Property from "crqlar-react-common/dist/components/Property";
import {useTranslation} from "react-i18next";
import {Membership} from "crqlar-react-common/dist/models/profile/membership.model";
import CDatePicker from "crqlar-react-common/dist/components/CDatePicker";

interface Props {
    id?: string;
    value?: Membership;
    onChange?: (membership?: Membership) => void;
    disabled?: boolean;
    index: number;
}

const MembershipField = (props: Props) => {

    const {t} = useTranslation()
    const updateField = (field: keyof Membership, value: any) => {
        props.onChange?.({...props.value, [field]: value})
    }

    return (
        <Stack gap={1} id={props.id} width={'100%'}>
            <Property title={t('Member Name')} labelAlignment={'top'}>
                <TextField
                    id={`member-name-${props.index}`}
                    data-testid={`member-name-${props.index}`}
                    value={props.value?.memberName}
                    onChange={(e) => updateField('memberName', e.target.value)}
                    fullWidth
                    size={'small'}
                    disabled={props.disabled}
                />
            </Property>

            <Property title={t('Membership Program')} labelAlignment={'top'}>
                <TextField
                    id={`membership-program-${props.index}`}
                    data-testid={`membership-program-${props.index}`}
                    value={props.value?.membershipProgram}
                    onChange={(e) => updateField('membershipProgram', e.target.value)}
                    fullWidth
                    size={'small'}
                    disabled={props.disabled}
                />
            </Property>

            <Property title={t('Membership Number')} labelAlignment={'top'}>
                <TextField
                    id={`membership-number-${props.index}`}
                    data-testid={`membership-number-${props.index}`}
                    value={props.value?.membershipNumber}
                    onChange={(e) => updateField('membershipNumber', e.target.value)}
                    fullWidth
                    size={'small'}
                    disabled={props.disabled}
                />
            </Property>

            <Property title={t('Membership Type')} labelAlignment={'top'}>
                <TextField
                    id={`membership-type-${props.index}`}
                    data-testid={`membership-type-${props.index}`}
                    value={props.value?.membershipType}
                    onChange={(e) => updateField('membershipType', e.target.value)}
                    fullWidth
                    size={'small'}
                    disabled={props.disabled}
                />
            </Property>

            <Property title={t('Membership Level')} labelAlignment={'top'}>
                <TextField
                    id={`membership-level-${props.index}`}
                    data-testid={`membership-level-${props.index}`}
                    value={props.value?.membershipLevel}
                    onChange={(e) => updateField('membershipLevel', e.target.value)}
                    fullWidth
                    size={'small'}
                    disabled={props.disabled}
                />
            </Property>

            <Property title={t('Effective Date')} labelAlignment={'top'}>
                <CDatePicker
                    id={`effective-date-${props.index}`}
                    data-testid={`effective-date-${props.index}`}
                    value={props.value?.effectiveDate}
                    onChange={(e) => updateField('effectiveDate', e)}
                    disabled={props.disabled}
                    dateOnly
                />
            </Property>

            <Property title={t('Expiration Date')} labelAlignment={'top'}>
                <CDatePicker
                    id={`expiration-date-${props.index}`}
                    data-testid={`expiration-date-${props.index}`}
                    value={props.value?.expirationDate}
                    onChange={(e) => updateField('expirationDate', e)}
                    disabled={props.disabled}
                    dateOnly
                />
            </Property>


            <Property title={t('Current points')} labelAlignment={'top'}>
                <TextField
                    id={`current-points-${props.index}`}
                    data-testid={`current-points-${props.index}`}
                    value={props.value?.currentPoints}
                    onChange={(e) => updateField('currentPoints', parseInt(e.target.value))}
                    fullWidth
                    size={'small'}
                    type={"number"}
                    disabled={props.disabled}
                />
            </Property>

        </Stack>
    )
}

export default MembershipField;
